/**
 * WD Icon with text — Mobile (max-width 1219.98px): ℹ toggles popover on tap; tap outside `[data-wd-iwt-root]` closes.
 * Desktop: `(hover:hover)` opens on ℹ/popover hover, closes after pointer leaves (short delay); coarse pointers use click like mobile.
 * Escape closes. Document click outside still dismisses desktop open popovers where applicable.
 */
(function () {
  var BP_MOBILE = '(max-width: 1219.98px)';
  var BP_HOVER = '(hover: hover)';
  var docBound;

  function isMobile() {
    return window.matchMedia(BP_MOBILE).matches;
  }

  /** Desktop layout + real hover capability (avoid “sticky” hover on touch/tablet widths). */
  function prefersHoverPopover() {
    return (
      !isMobile() &&
      typeof window.matchMedia !== 'undefined' &&
      window.matchMedia(BP_HOVER).matches
    );
  }

  function syncAria(block) {
    var btn = block.querySelector('.wd-iwt__info-btn');
    if (!btn) return;
    btn.setAttribute('aria-expanded', block.classList.contains('is-iwt-popover-open') ? 'true' : 'false');
  }

  function closeAllInRoot(root, except) {
    root.querySelectorAll('.wd-iwt__block.is-iwt-popover-open').forEach(function (b) {
      if (!except || b !== except) {
        b.classList.remove('is-iwt-popover-open');
        syncAria(b);
      }
    });
  }

  function bindOutsideClose() {
    if (docBound) return;
    docBound = true;
    document.addEventListener(
      'click',
      function (e) {
        document.querySelectorAll('[data-wd-iwt-root]').forEach(function (root) {
          var hasOpenPopover = !!root.querySelector('.wd-iwt__block.is-iwt-popover-open');

          if (isMobile()) {
            if (root.contains(e.target)) return;
            closeAllInRoot(root, null);
          } else {
            if (!hasOpenPopover) return;
            /* Desktop: dismiss unless click is inside the open popover (fine-pointer may use hover; clicks still close) */
            if (e.target.closest('.wd-iwt__block.is-iwt-popover-open .wd-iwt__popover')) return;
            if (e.target.closest('.wd-iwt__block.is-iwt-popover-open .wd-iwt__info-btn')) return;
            closeAllInRoot(root, null);
          }
        });
      },
      false
    );
  }

  function initRoot(root) {
    if (!root || root.dataset.wdIwtInit === '1') return;
    root.dataset.wdIwtInit = '1';
    bindOutsideClose();

    root.querySelectorAll('.wd-iwt__block--has-info').forEach(function (block) {
      var pop = block.querySelector('.wd-iwt__popover');
      var infoBtn = block.querySelector('.wd-iwt__info-btn');
      var closeBtn = block.querySelector('.wd-iwt__popover-close');
      var hoverLeaveTimer = null;

      function clearHoverLeaveTimer() {
        if (hoverLeaveTimer !== null) {
          clearTimeout(hoverLeaveTimer);
          hoverLeaveTimer = null;
        }
      }

      function scheduleHoverClose() {
        if (!prefersHoverPopover()) return;
        clearHoverLeaveTimer();
        hoverLeaveTimer = setTimeout(function () {
          hoverLeaveTimer = null;
          block.classList.remove('is-iwt-popover-open');
          syncAria(block);
        }, 140);
      }

      function openForHover() {
        if (!prefersHoverPopover()) return;
        clearHoverLeaveTimer();
        closeAllInRoot(root, block);
        block.classList.add('is-iwt-popover-open');
        syncAria(block);
      }

      if (infoBtn) {
        infoBtn.addEventListener('mouseenter', openForHover);

        infoBtn.addEventListener('mouseleave', function () {
          scheduleHoverClose();
        });

        infoBtn.addEventListener('click', function (e) {
          /* Fine-pointer desktop: hover opens; ignore mouse clicks. Keyboard activation (detail 0) still toggles. */
          if (prefersHoverPopover()) {
            e.stopPropagation();
            if (e.detail === 0) {
              closeAllInRoot(root, block);
              block.classList.toggle('is-iwt-popover-open');
              syncAria(block);
              clearHoverLeaveTimer();
            }
            return;
          }
          e.stopPropagation();
          closeAllInRoot(root, block);
          block.classList.toggle('is-iwt-popover-open');
          syncAria(block);
        });
      }

      if (pop) {
        pop.addEventListener('mouseenter', function () {
          if (prefersHoverPopover()) clearHoverLeaveTimer();
        });
        pop.addEventListener('mouseleave', function () {
          scheduleHoverClose();
        });

        pop.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          clearHoverLeaveTimer();
          block.classList.remove('is-iwt-popover-open');
          syncAria(block);
        });
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeAllInRoot(root, null);
    });

    window.addEventListener(
      'resize',
      function () {
        closeAllInRoot(root, null);
      },
      { passive: true }
    );
  }

  document.querySelectorAll('[data-wd-iwt-root]').forEach(initRoot);

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target && e.target.querySelector && e.target.querySelector('[data-wd-iwt-root]');
    if (sec) initRoot(sec);
  });
})();
